import React from 'react';

import External from 'components/layout/External';
import Logged from 'components/layout/Logged';
import { AuthService } from 'modules/auth';

const Routing = () => {
  if (AuthService.isLogged) {
    return <Logged />;
  }

  return <External />;
};

export default Routing;
